import {useFormik} from "formik";
import {useTranslation} from "react-i18next";
import * as yup from "yup";
import {useCreateStationLink} from "../../query";
import MDInput from "../../../../materialDashboard/components/MDInput";
import {Dialog, DialogContent, DialogTitle} from "@mui/material";
import MDButton from "../../../../materialDashboard/components/MDButton";
import MDLoadingButton from "../../../../components/MDLoadingButton";
import DialogActions from "@mui/material/DialogActions";
import React from "react";


const CreateLinkDialog = ({open, onClose, stationId}) => {
    const {t} = useTranslation(["stations", "validation"]);
    const createStationLink = useCreateStationLink(stationId);

    const formik = useFormik({
        initialValues: {
            link: "",
            title: "",
            description: "",
        },
        validationSchema: yup.object({
            link: yup.string().url().required(t('validation:required')),
            title: yup.string().required(t('validation:required')),
            description: yup.string()
        }),
        onSubmit: async (values) => {
            await createStationLink.mutateAsync({...values, stationId: stationId});
            onClose();
        },
    });

    return <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
        <DialogTitle>{t('station.cardMedia.createLinkTitle')}</DialogTitle>
        <DialogContent>
            <MDInput label={t('station.cardMedia.linkTitle')}
                     name="title"
                     value={formik.values.title}
                     onChange={formik.handleChange}
                     error={formik.touched.title && Boolean(formik.errors.title)}
                     helperText={formik.touched.title && formik.errors.title}
                     fullWidth
                     sx={{mt: 1}}/>
            <MDInput label={t('station.cardMedia.linkDescription')}
                     name="description"
                     value={formik.values.description}
                     onChange={formik.handleChange}
                     error={formik.touched.description && Boolean(formik.errors.description)}
                     helperText={formik.touched.description && formik.errors.description}
                     fullWidth
                     sx={{mt: 1}}/>
            <MDInput label={t('station.cardMedia.link')}
                     name="link"
                     value={formik.values.link}
                     onChange={formik.handleChange}
                     error={formik.touched.link && Boolean(formik.errors.link)}
                     helperText={formik.touched.link && formik.errors.link}
                     fullWidth
                     sx={{mt: 1}}
            />
        </DialogContent>
        <DialogActions>
            <MDButton onClick={onClose} color="info" variant="outlined">
                {t('station.cardMedia.cancelButton')}
            </MDButton>
            <MDLoadingButton onClick={formik.handleSubmit}
                             color="info"
                             variant="gradient"
                             loading={createStationLink.isLoading}>
                {t('station.cardMedia.saveButton')}
            </MDLoadingButton>
        </DialogActions>
    </Dialog>
}

export default CreateLinkDialog;